import { Db, MongoClient } from "mongodb";
import { MongoDbConnection } from "~/services/MongoDbConnection";

let mongoConn!: MongoDbConnection;

export const useMongoDbConnection = () => {
  function getDbNameFromUri(): string {
    const regex = /(?<=mongodb(?:\+srv)?:\/\/[^/]+\/)[^?]+/;
    const match = mongodbUri.match(regex);

    if (match) {
      return match[0];
    } else {
      throw Error("Mongo db name cannot be extracted from the URI");
    }
  }

  function initConnection(): void {
    if (!mongoConn) {
      mongoConn = new MongoDbConnection(
        mongodbUri,
        mongodbIsDirectConn.toString() === "true"
      );

      // mongoConn.connect();
    }
  }

  const runtimeConfig = useRuntimeConfig();
  const { mongodbUri, mongodbIsDirectConn } = runtimeConfig;
  const dbName = getDbNameFromUri();

  const connect = async (): Promise<void> => {
    return mongoConn.connect();
  };

  const database = (): Db => {
    if (mongoConn) {
      return mongoConn.client.db(dbName);
    } else {
      throw Error("Call first to the connect function");
    }
  };

  initConnection();

  return {
    connect,
    database
  };
};
